// Copyright (c) Microsoft. All rights reserved.

import { BaseService } from './BaseService';

interface IFileList {
    files: IFile[];
}

export interface IFile {
    fileName: string;
    lastUpdated: string;
    fileSize: number;
}

export class FileService extends BaseService {
    public importFileAsync = async (files: File[], accessToken: string) => {
        const formData = new FormData();
        for (const file of files) {
            formData.append('formFiles', file);
        }

        await this.getResponseAsync(
            {
                commandPath: 'files',
                method: 'POST',
                body: formData,
            },
            accessToken,
        );
    };

    public listFilesAsync = async (accessToken: string) => {
        const fileList = await this.getResponseAsync<IFileList>(
            {
                commandPath: 'files',
                method: 'GET',
            },
            accessToken,
        );

        return fileList.files;
    };

    public deleteFileAsync = async (fileName: string, accessToken: string): Promise<void> => {
        await this.getResponseAsync(
            {
                commandPath: `file/${fileName}`,
                method: 'DELETE',
            },
            accessToken,
        );
    };
}
